/* eslint-disable */
export default {
  _click: 'click',
  _menu_1: 'menu_1',
  _menu_2: 'menu_2',
  _place_item_1: 'place_item_1',
  _place_item_2: 'place_item_2',
  _save_print_startOver: 'save-print-startOver',
  _undo: 'undo',
}